import styles from './DefaultDesign.module.css'
import React, {
  useState,
  useContext,
  useMemo,
  useCallback,
  useEffect,
  useRef,
} from 'react'
import { observer } from 'mobx-react-lite'
import { toJS } from 'mobx'
import { BuilderContext } from '../../../store/store.Builder'
import { styleNames } from '../../../SidebarEditor/SidebarEditor'
import FieldProperty from '../../../SidebarEditor/components/FieldProperty/FieldProperty'

const DefaultDesign = observer(() => {
  const renderCountRef = useRef(0)
  renderCountRef.current += 1
  const builderContext = useContext(BuilderContext)

  useEffect(() => {
    console.log(`SidebarEditorModal render count: ${renderCountRef.current}`)
  })

  const categories = [
    {
      name: 'field',
      type: 'field',
      style: styles.activecategory,
      data: { ...builderContext.field_default_design },
    },
    {
      name: 'label',
      type: 'label',
      style: '',
      data: { ...builderContext.label_default_design },
    },
    {
      name: 'Description',
      type: 'description',
      style: '',
      data: { ...builderContext.description_default_design },
    },
    {
      name: 'Input',
      type: 'input',
      style: '',
      data: { ...builderContext.input_default_design },
    },
  ]

  useEffect(() => {
    if (categories.length > 0) {
      builderContext.setSelectedFieldDefaultDesign(categories[0])
    }
  }, [])

  const handleCategoryClick = (category) => {
    builderContext.setSelectedFieldDefaultDesign(category)
  }

  const handleChange = useCallback(
    (name, value) => {
      const newValue =
        value && value.target !== undefined ? value.target.value : value
      const updatedField = {
        ...builderContext.selectedFieldDefaultDesign.data,
        [name]: newValue,
      }

      builderContext.handleUpdateDefaultDesign(
        updatedField,
        builderContext.selectedFieldDefaultDesign.type
      )
    },
    [builderContext.selectedFieldDefaultDesign]
  )

  const editableProperties = useMemo(() => {
    if (!builderContext.selectedFieldDefaultDesign) {
      return []
    }
    const propertyNames = Object.keys(styleNames).filter((name) =>
      builderContext.selectedFieldDefaultDesign?.data.hasOwnProperty(name)
    )
    return propertyNames
  }, [builderContext.selectedFieldDefaultDesign])

  const categoryDataMap = categories.reduce((acc, category) => {
    acc[category.type] = category.data
    return acc
  }, {})

  function handleClick(componentName, event) {
    event.stopPropagation()
    if (componentName === 'page') {
      builderContext.setSelectedFieldDefaultDesign(null)
    } else {
      const category = categories.find((cat) => cat.type === componentName)

      if (category) {
        builderContext.setSelectedFieldDefaultDesign(category)
      }
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.left__container}>
        <div className={styles.header}>
          <div className={styles.categorySelector}>
            {categories.map((category) => (
              <div
                key={category.name}
                className={`${styles.titlecategory} ${
                  builderContext.selectedFieldDefaultDesign?.type ===
                  category.type
                    ? styles.activecategory
                    : ''
                }`}
                onClick={() => handleCategoryClick(category)}
              >
                {category.name}
              </div>
            ))}
          </div>
        </div>

        <div className={styles.sidebar__editor}>
          {editableProperties.map((name) => {
            const { Component, label, title } = styleNames[name]
            return (
              <FieldProperty
                key={name}
                name={name}
                label={label}
                title={title}
                value={builderContext.selectedFieldDefaultDesign.data[name]}
                onChange={
                  name === 'options'
                    ? (value) => handleChange(name, value)
                    : typeof builderContext.selectedFieldDefaultDesign.data[
                        name
                      ] === 'boolean'
                    ? (value) => handleChange(name, value)
                    : (event) => handleChange(name, event)
                }
                Component={Component}
              />
            )
          })}
        </div>
      </div>
      <div className={styles.right__container}>
        <div className={styles.header}>
          <div className={styles.categorySelector}>
            <div
              className={`${styles.titlecategory}  ${styles.activecategory}`}
            >
              Aperçu en direct
            </div>
          </div>
        </div>
        <div
          onClick={(e) => handleClick('page', e)}
          className={styles.fake__page}
        >
          <div
            className={`${styles.field} ${
              builderContext.selectedFieldDefaultDesign?.type === 'field'
                ? styles.active
                : ''
            }`}
            style={categoryDataMap.field}
            onClick={(e) => handleClick('field', e)}
          >
            <div
              className={`${styles.label} ${
                builderContext.selectedFieldDefaultDesign?.type === 'label'
                  ? styles.active
                  : ''
              }`}
              style={categoryDataMap.label}
              onClick={(e) => handleClick('label', e)}
            >
              Ceci est un super titre
            </div>
            <div
              className={`${styles.description} ${
                builderContext.selectedFieldDefaultDesign?.type ===
                'description'
                  ? styles.active
                  : ''
              }`}
              style={categoryDataMap.description}
              onClick={(e) => handleClick('description', e)}
            >
              Ceci est une super description
            </div>
            <div
              className={`${styles.input} ${
                builderContext.selectedFieldDefaultDesign?.type === 'input'
                  ? styles.active
                  : ''
              } ${'container__input__fields'}`}
              onClick={(e) => handleClick('input', e)}
            >
              <input
                type="text"
                style={categoryDataMap.input}
                placeholder={'This is a text input'}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
})

export default DefaultDesign
